import { Link } from 'react-router-dom';
import { Reveal } from './Reveal';

type CtaBandProps = {
  title?: string;
  primaryLabel?: string;
  primaryTo?: string;
  secondaryLabel?: string;
  secondaryTo?: string;
};

export function CtaBand({
  title = '오늘 밤, 당신의 자리를 준비해 두겠습니다.',
  primaryLabel = '예약하기',
  primaryTo = '/reserve',
  secondaryLabel,
  secondaryTo
}: CtaBandProps) {
  return (
    <section className="tm-cta-band tm-section">
      <div className="tm-container">
        <Reveal>
          <h2 className="tm-h2">{title}</h2>
          <div className="tm-hero-actions">
            <Link className="tm-btn tm-btn--solid" to={primaryTo}>{primaryLabel}</Link>
            {secondaryLabel && secondaryTo && (
              <Link className="tm-btn tm-btn--ghost" to={secondaryTo}>{secondaryLabel}</Link>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
